import { useMemo } from 'react';
import { JIRA_HOSTS_TYPES } from '../jira.oauth2.consts';
import CloudForm from './CloudForm';

const mapHostTypeToForm = {
  [JIRA_HOSTS_TYPES.CLOUD]: CloudForm
};

const HostForm = ({ hostType }) => {
  const HostForm = useMemo(() => mapHostTypeToForm[hostType], [hostType]);

  return HostForm ? <HostForm /> : null;
};

export default HostForm;
